export default "__VITE_ASSET__6cb8e43f__"